import { Typography } from '@mui/material'
import { useFormContext } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'

import Space from 'components/Space'
import { DataSampling } from 'features/workspace/types/dataSampling'
import { generateSelector } from 'providers/product-fruits/utils'
import { Schema } from '../../form/schema'

export const HeaderDescriptionText = (): React.JSX.Element => {
  const { t } = useTranslation('features/performance', { keyPrefix: 'prebidStack' })
  const { watch } = useFormContext<Schema>()

  const sampling: DataSampling = watch()['dataSampling']

  return (
    <>
      <Trans
        i18nKey='description.main'
        t={t}
      />

      {sampling !== '100' && (
        <>
          <Space />

          <Trans
            components={{
              bold: (
                <Typography
                  data-product-fruits={generateSelector({ hint: 2 })}
                  sx={{ fontWeight: 'bold' }}
                  variant='inherit'
                />
              ),
            }}
            i18nKey='description.note'
            t={t}
            values={{ sampling }}
          />
        </>
      )}
    </>
  )
}
